import { events } from "./constants"

const dispatchSetChanging = (boolean: Boolean, delay = 500) => {
    setTimeout(() => {
        document.dispatchEvent(new CustomEvent(events.SETCHANGING, { detail: { changing: boolean } }))
    }, delay)
}

const onMobile = (cb: Function) => {
    if (window.innerWidth < 576) {
        cb()
    }
}

export { dispatchSetChanging, onMobile }